export enum NotificationTypeEnum {
  PublicOfferApplicationWithExtractionCreated = 'PublicOfferApplicationWithExtractionCreated',
  JobOrderApplicationExpired = 'JobOrderApplicationExpired',
  JobOrderApplicationCreated = 'JobOrderApplicationCreated',
  JobOrderMatched = 'JobOrderMatched',
  CQScheduled = 'CQScheduled',
  JobOrderApplicationRejected = 'JobOrderApplicationRejected',
  JobOrderApplicationRejectedAfterCI = 'JobOrderApplicationRejectedAfterCI',
  JobOrderApplicationCIScheduled = 'JobOrderApplicationCIScheduled',
  JobOrderApplicationAcceptedAfterCI = 'JobOrderApplicationAcceptedAfterCI',
  SavedOfferExpired = 'SavedOfferExpired',
  SavedOfferReminder = 'SavedOfferReminder',
  JobOrderApplicationCIFinished = 'JobOrderApplicationCIFinished',
}
